var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.93 50.47C21.8343 50.47 25.81 46.4943 25.81 41.59C25.81 36.6857 21.8343 32.71 16.93 32.71C12.0258 32.71 8.05005 36.6857 8.05005 41.59C8.05005 46.4943 12.0258 50.47 16.93 50.47Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 56.38C7.54 52.76 11.83 50.46 16.93 50.46C22.03 50.46 26.32 52.76 29.36 56.38",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4201 31.19H29.2401C28.6001 31.19 28.0801 30.67 28.0801 30.03V17.85C28.0801 10.48 34.0501 4.51001 41.4201 4.51001C48.7901 4.51001 54.7601 10.48 54.7601 17.85C54.7601 25.22 48.7901 31.19 41.4201 31.19Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4202 12.8V18.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8201 16.16L41.4201 18.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0601 22.88L41.4201 18.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7802 22.88L41.4202 18.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0202 16.16L41.4202 18.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.26,
    height: 56.88,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.b557083e0525c1183dd4d7c6baf3df85.svg";
export { ForwardRef as ReactComponent };